export const useApiAdvertisersIdModelsTranslationKeys = {
  offerModelsOfferStatusIsInactive: 'offer.models-offer-status-is-inactive',
  offerModelsOfferStatusWorkingConditionsAreNotAccepted: 'offer.models-offer-status-working-conditions-are-not-accepted',
  offerModelsOfferRulesAreNotAccepted: 'offer.models-offer-rules-are-not-accepted',
}
